module.exports = __webpack_public_path__ + "static/media/Mia 20x60 - Anthracite Geometric Flower 4.1d7143b9.jpg";